import { computed, effect, Injectable, isDevMode, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators'
import { AppComponent } from '../app.component';
import { TokenStorageService } from './token-storage.service';
import { AuthResponse } from '../_helper/AuthResponse';
import { Router } from '@angular/router';
import { User } from '../_helper/User';

type AuthState = {
  // user: User | null;
  token: string | null;
  is_auth: boolean;
  loading: boolean;
};

const API_AUTH_ENDPOINT = '/auth';
@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private _accessTokenKey = "accessToken";
  private _storedToken = localStorage.getItem(this._accessTokenKey);
  private userSubject = new BehaviorSubject<User>({ username: '', isLoggedIn: false, loginAction: false });
  isLoggedIn$ = this.userSubject.asObservable();
  private _state = signal<AuthState>({
    //  user: null,
    token: this._storedToken,
    is_auth: this._storedToken !== null, // You may check the token validity here
    loading: false,
  });
  token = computed(() => this._state().token);
  loading = computed(() => this._state().loading);
  isAuth = computed(() => this._state().is_auth);
  constructor(private http: HttpClient, private tokenservice: TokenStorageService, private router: Router) {
    effect(() => {
      const token = this.token();
      if (token !== null) {
        localStorage.setItem(this._accessTokenKey, token);
      } else {
        localStorage.removeItem(this._accessTokenKey);
      }
    });

  }
  register(postData): Observable<any> {
    return this.http.post(AppComponent.baseUrl + API_AUTH_ENDPOINT + '/register', postData, { responseType: 'text' });
  }
  login(postData): Observable<any> {
    return this.http.post(AppComponent.baseUrl + API_AUTH_ENDPOINT + '/login', postData, { responseType: 'text' });
  }
  callLoginWithPin(postData): Observable<any> {
    return this.http.post<AuthResponse>(AppComponent.baseUrl + API_AUTH_ENDPOINT + '/login-with-pin', postData);
  }

  checkLoggedIn(): Observable<any> {
    return this.http.get(AppComponent.baseUrl + API_AUTH_ENDPOINT + '/check-login');
  }

  requestFamilyCode(email: string): Observable<any> {
    return this.http.post(AppComponent.baseUrl + API_AUTH_ENDPOINT + '/request-code', { email }, { responseType: 'text' });
  }

  requestPin(userId: number): Observable<any> {
    return this.http.post(AppComponent.baseUrl + API_AUTH_ENDPOINT + '/request-pin', { user_id: userId }, { responseType: 'text' });
  }

  getSubscriptionInfo(): Observable<any> {
    return this.http.get(AppComponent.baseUrl + API_AUTH_ENDPOINT + '/subscription-info');
  }

  addMember(data: { subscription_id: number; username: string; email: string; password: string }): Observable<any> {
    return this.http.post(AppComponent.baseUrl + API_AUTH_ENDPOINT + '/add-member', data, { responseType: 'text' });
  }

  betaToggle(): Observable<any> {
    return this.http.post(AppComponent.baseUrl + API_AUTH_ENDPOINT + '/beta-toggle', {});
  }



  loginWithPin(pin: string, userId: number): Observable<any> {
    return this.callLoginWithPin({ pin, user_id: userId }).pipe(
      tap((result) => {
        this._state.update((state) => {
          this.tokenservice.saveToken(result.token);
          this.tokenservice.saveUser(result);
          state.token = result.token;
          state.is_auth = true;
          state.loading = false;
          this.userSubject.next({ username: result.username, isLoggedIn: true, loginAction: true });
          return state;
        });
      })
    );
  }

  isLoggedIn(): void {
    this.checkLoggedIn().subscribe({
      next: (response) => {
        const stored = this.tokenservice.getUser();
        if (response.success && stored) {
          this.tokenservice.saveUser({ ...stored, beta_features: response.beta_features });
        }
        this.userSubject.next({ username: stored?.username ?? '', isLoggedIn: response.success, loginAction: false });
      },
      error: (error) => {
        if (isDevMode()) console.error('checkLoggedIn error:', error);
        this.userSubject.next({ username: '', isLoggedIn: false, loginAction: false });
      }
    });
  }
}


